import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { UntypedFormControl, UntypedFormArray, UntypedFormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

import { GSFReport } from "../GSF-report.service";
import { activityInput } from "../models/activityInput.model";
import { CONSTANT } from "../constants/num-text-box.const";

@Component({
  selector: "app-num-text-box",
  templateUrl: "./num-text-box.component.html"
})
export class NumTextBoxComponent implements OnInit {
  public txtValue: string;
  @Output() sendDataToForm: EventEmitter<any> = new EventEmitter<any>();
  newObj: any;
  @Input() activity: activityInput;
  @Input() isRequired: boolean;

  @Input() activityControl: UntypedFormControl;
  @Input()
  activityInputList: activityInput[];
  @Input()
  questionForm: UntypedFormGroup;

  selectedlang: string;
  customMaxMin = "";
  decimalPattern: string;
  decimalLimit = 2;
  minValue = 0.01;

  constructor(public report: GSFReport, public translate: TranslateService) {
    translate.setDefaultLang(CONSTANT.ENG);
    this.selectedlang = CONSTANT.ENG;
  }

  ngOnInit() {
    this.minValue = this.activity.minValue > 0 ? this.activity.minValue : this.minValue;
    if(this.activity.defaultDisable === true) {
      this.activityControl.disable();
    }

    this.onChange();

    this.activityControl.setValidators([
      Validators.min(this.minValue),
      Validators.max(this.activity.maxValue),
      Validators.pattern(CONSTANT.PATTERN)
    ]);
    if (this.activity.decimalLimit === 0) {
        this.decimalPattern = `^[0-9]*$`
      } else {
        this.decimalLimit = this.activity.decimalLimit ? this.activity.decimalLimit : 2;
        this.decimalPattern = `\\d*(\\.?\\d{1,${this.decimalLimit}})?$`
      }

  }

  private onChange() {
    this.activityControl.valueChanges.subscribe(val => { //nosonar
      this.activity.ans = val;
      this.customMaxMin = "";
      if(this.activity["dependancy"] && this.activity["dependancy"].flag && this.activity["dependancy"].rule){
        const deptId = this.activity["dependancy"]["depId"];
        const rule = this.activity["dependancy"].rule;
        this.activityInputList.forEach((inp, index) => {
          if (inp.inputControlID === deptId) {
            const inpCtls = this.questionForm.get("inputList") as UntypedFormArray;
            const inpCtl = inpCtls.controls[index] as UntypedFormControl;
            if (inpCtl && inpCtl.value) {
              if (rule === "gtr") {
                this.activityControl.setValidators([
                  Validators.max(inpCtl.value),
                  Validators.min(this.minValue),
                  Validators.pattern(this.decimalPattern)
                ]);
                inpCtl.setValidators([
                  Validators.max(this.activity.maxValue),
                  Validators.min(this.activityControl.value),
                  Validators.pattern(this.decimalPattern)
                ]);
              } else if (rule === "lsr") {
                this.activityControl.setValidators([
                  Validators.max(this.activity.maxValue),
                  Validators.min(inpCtl.value),
                  Validators.pattern(this.decimalPattern)
                ]);
                inpCtl.setValidators([
                  Validators.max(this.activityControl.value),
                  Validators.min(this.minValue),
                  Validators.pattern(this.decimalPattern)
                ]);
              }
              inp["customMaxMin"] = this.activityControl.value;
              this.activity["customMaxMin"] = inpCtl.value;
              this.activityControl.updateValueAndValidity({emitEvent:false});
              inpCtl.updateValueAndValidity({emitEvent:false});
            }
          }
        });

      }
    });
  }

  onlyNumeric(event) {
    return event.charCode === 8 || event.charCode === 0
      ? null
      : event.charCode >= 48 && event.charCode <= 57;
  }
}
